import i18n from '../../../../../base-dictionary';
import { secondaryBase } from '../../../../../styles/design-tokens';
import { Icon } from '../../../../../ui-library/icon/icon';
import type { ExtendedComboboxItem } from '../../../../../ui-library/select/select.type';
import { ThroughputMode } from '../../initiative-performance.type';

/**
 * Returns a list of options for the throughput mode dropdown
 * Each option contains a label for display and a value from the ThroughputMode enum
 *
 * @returns {ExtendedComboboxItem[]} Array of options for the throughput mode selection
 */
const getThroughputModeOptions = (): ExtendedComboboxItem[] => {
  return [
    {
      label: i18n.t('strategy.initiative_performance.labels.initiative_progress'),
      value: ThroughputMode.InitiativeProgress,
      leftSection: <Icon name="lightbulb" size={20} color={secondaryBase} />,
    },
    {
      label: i18n.t('strategy.initiative_performance.labels.contributing_epics'),
      value: ThroughputMode.ContributingEpics,
      leftSection: <Icon name="move_down" size={20} color={secondaryBase} />,
    },
    {
      label: i18n.t('strategy.initiative_performance.labels.contributing_teams'),
      value: ThroughputMode.ContributingTeams,
      leftSection: <Icon name="people_alt" size={20} color={secondaryBase} />,
    },
  ];
};

export { getThroughputModeOptions };
